<template>
  <div v-loading="loading" style="margin-top: 20px">
    <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px">
      <div class="apply-form-wrap">
        <h4>个人信息</h4>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名:">{{ userInfo.name }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学号:">{{ userInfo.idnumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级:">{{ userInfo.className }}</el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="手机:" prop="phone" :rules="[{ required: true, message: '请输入手机' }]">
              <el-input v-model="form.phone" size="medium" placeholder="请输入手机" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="apply-form-wrap">
        <h4>{{ [4].includes(+apply_type) ? '原课程调整申请单' : '课程情况' }}</h4>
        <el-row>
          <el-col :span="16">
            <el-form-item label="课程名称：" :rules="[{ required: true, message: '请选择课程' }]">
              <el-input v-model="currentCourse.name" readonly placeholder="请选择课程" style="width: 70%; margin-right: 10px" size="medium"></el-input>
              <el-button type="primary" size="medium" @click="showCourseDialog('currentCourse')">选择</el-button>
            </el-form-item>
          </el-col>
          <template v-if="currentCourse.name">
            <el-col :span="8">
              <el-form-item label="课程编号：">{{ currentCourse.code }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程性质：">{{ currentCourse.nature }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课班级：">{{ currentCourse.class }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学分：">{{ currentCourse.credit }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学时：">{{ currentCourse.class_hours }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="讲课教师：">{{ currentCourse.teacher }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试时间：">{{ currentCourse.examTime || '-' }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学年：">{{ currentCourse.schoolYear }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学期：">{{ currentCourse.semester }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试地点：">{{ currentCourse.examPlace || '-' }}</el-form-item>
            </el-col>
            <el-col v-if="+apply_type===2" :span="8">
              <el-form-item label="成绩">{{ currentCourse.levelScore || '-' }}</el-form-item>
            </el-col>
          </template>
        </el-row>
      </div>
      <div class="apply-form-wrap">
        <h4>目标课程</h4>
        <el-row>
          <el-col :span="16">
            <el-form-item label="课程名称：" :rules="[{ required: true, message: '请选择课程' }]">
              <el-input v-model="targetCourse.name" readonly placeholder="请选择课程" style="width: 70%; margin-right: 10px" size="medium"></el-input>
              <el-button type="primary" size="medium" @click="showCourseDialog('targetCourse')">选择</el-button>
            </el-form-item>
          </el-col>
          <template v-if="targetCourse.name">
            <el-col :span="8">
              <el-form-item label="课程编号：">{{ targetCourse.code }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程性质：">{{ targetCourse.nature }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课班级：">{{ targetCourse.class }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学分：">{{ targetCourse.credit }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学时：">{{ targetCourse.class_hours }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="讲课教师：">{{ targetCourse.teacher }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学年：">{{ targetCourse.schoolYear }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学期：">{{ targetCourse.semester }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试时间：">{{ targetCourse.examTime || '-' }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试地点：">{{ targetCourse.examPlace || '-' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-input v-model="form.apply_reason" type="textarea" rows="5" placeholder="请输入申请原因" :autosize="{ minRows: 3, maxRows: 6 }" />
            </el-col>
          </template>
        </el-row>
      </div>
      <el-form-item label-width="0" style="margin-top: 20px">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="isloading" @click="applySubmit">提交</el-button>
      </el-form-item>
    </el-form>

    <!-- 选择课程弹窗 -->
    <course-select-dialog v-if="showCourseSelectDialog" :visible.sync="showCourseSelectDialog" :type="type" @checkSubmit="selectCourse" />
    <CourseSelectDialog2 v-if="showCourseSelectDialog2" :visible.sync="showCourseSelectDialog2" :type="type" :cb_id="cb_id" @checkSubmit="selectCourse" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { courseApplyHook } from '@/hooks/courseApplyFormHook'
import CourseSelectDialog from '../../components/CourseSelectDialog'
import CourseSelectDialog2 from '../../components/CourseSelectDialog2.vue'
import { Message } from 'element-ui'
import API from '@/api'
import Router from '@/router'
const isloading = ref(false)
const { userInfo, loading, formRules, cancelSubmit } = courseApplyHook()

const showCourseSelectDialog = ref(false)
const showCourseSelectDialog2 = ref(false)
const form = ref({
  phone: '', // 手机

  apply_ct_id: '', // 申请课程id
  apply_reason: '', // 申请理由
  apply_type: '', // 申请类型
  target_ct_id: '' // 目标课程id
})
form.value.phone = Router.currentRoute.query.m
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  type: {
    type: Number,
    default: () => 0
  }
})
const currentCourse = ref({})
const targetCourse = ref({})
const apply_type = ref('2')
const {
  params: { typeid }
} = Router.currentRoute
apply_type.value = typeid

const dialogType = ref('')
const cb_id = ref(0)
function showCourseDialog(type) {
  dialogType.value = type

  // showCourseSelectDialog2
  if (dialogType.value === 'currentCourse') {
    this.showCourseSelectDialog = true
  } else {
    // 缓修，缓考、免修不免考、免修免考
    // 再考、缓修在修、重修

    if (!cb_id.value) {
      let str = '请先选择课程情况'
      switch (props.type) {
        case 4:
          str = '请先选择原课程调整申请单'
          break
      }
      Message.error(str)
      return
    } else {
      this.showCourseSelectDialog2 = true
    }
  }
}

function selectCourse(course) {
  showCourseSelectDialog2.value = false
  showCourseSelectDialog.value = false
  if (dialogType.value === 'currentCourse') {
    currentCourse.value = course.value
    form.value.target_ct_id = course.value.ctId
    targetCourse.value = ''
    cb_id.value = course.value.cb_id
  } else {
    targetCourse.value = course.value
    form.value.apply_ct_id = course.value.ctId
  }
}

function applySubmit() {
  submit(form.value, isloading.value)
}
const formRef = ref()
function submit(formData) {
  const {
    params: { typeid }
  } = Router.currentRoute
  formData.apply_type = typeid

  formRef.value.validate(valid => {
    if (valid) {
      if (!targetCourse.value.name) {
        Message.error('请选择目标课程')
        return
      }
      if (!currentCourse.value.name) {
        Message.error('课程情况')
        return
      }
      isloading.value = true
      API.MBACourseChangeApply(formData)
        .then(res => {
          if (+res.code === 200) {
            Message.success(res.msg)
            Router.replace({ name: 'ApplyAdjustment' })
          } else {
            Message.error(res.msg)
          }

          isloading.value = false
        })
        .catch(_ => {
          isloading.value = false
        })
    } else {
      console.log('error submit!!')
      return false
    }
  })
}
</script>

<style lang="scss" scoped>
.apply-form-wrap {
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 30px;

  h4 {
    margin-bottom: 17px;
  }

  :deep(.el-input) {
    width: 230px;
  }

  :deep(.el-radio-group) {
    width: 100%;
  }

  :deep(.avatar-uploader),
  :deep(.avatar-uploader-icon) {
    width: 180px;
    height: 100px;
    line-height: 100px;
  }

  :deep(.el-textarea .el-textarea__inner) {
    resize: none;
  }

  .prove-image {
    &.disabled {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 88;
        display: block;
        width: 180px;
        height: 100px;
        background-color: rgba(245, 247, 250, 0.4);
        cursor: not-allowed;
        filter: grayscale(1);
      }
    }
  }
}
</style>
